<template>
  <div class="content" v-if="landscape">
    <Touch :slideHandler="slideHandler">
      <div class="dashboard" ref="dashboard" :style="{width: dashboardWidth}" @wheel="wheelHandler($event)">
        <router-link :to="{name: 'Detail', params: {id: 0}}">
          <Part1 :landscape="landscape"></Part1>
        </router-link>
        <router-link :to="{name: 'Detail', params: {id: 1}}">
          <Part2 :landscape="landscape"></Part2>
        </router-link>
        <router-link :to="{name: 'Detail', params: {id: 2}}">
          <Part3 :landscape="landscape"></Part3>
        </router-link>
      </div>
      <div class="mouse">
        <img src="../assets/icon_mouse.png" alt="">
        <div class="btn-left" @click="moveLeft"></div>
        <div class="btn-right" @click="moveRight"></div>
      </div>
    </Touch>
  </div>
  <div class="content" v-animate-css="animationInObject" v-else>
    <Touch :slideHandler="slideHandler">
      <div class="dashboard-portrait" ref="dashboard" :style="{width: dashboardWidth}" @wheel="wheelHandler($event)">
        <router-link :to="{name: 'Detail', params: {id: 0}}">
          <Part1 :landscape="landscape"></Part1>
        </router-link>
        <router-link :to="{name: 'Detail', params: {id: 1}}">
          <Part2 :landscape="landscape"></Part2>
        </router-link>
        <router-link :to="{name: 'Detail', params: {id: 2}}">
          <Part3 :landscape="landscape"></Part3>
        </router-link>
      </div>
      <div class="mouse">
        <img src="../assets/icon_mouse.png" alt="">
        <div class="btn-left" @click="moveToPortrait(-1)"></div>
        <div class="btn-right" @click="moveToPortrait(1)"></div>
      </div>
    </Touch>
  </div>
</template>

<script>
import Part1 from './Dashboard/Part1.vue'
import Part2 from './Dashboard/Part2.vue'
import Part3 from './Dashboard/Part3.vue'
import Touch from './Touch'
export default {
  data () {
    return {
      dashboardWidth: 0,
      animationInObject: {
        classes: 'slideInRight',
        delay: 0
      },
      animationInObject1: {
        classes: 'slideInRight',
        delay: 500
      },
      animationInObject2: {
        classes: 'slideInRight',
        delay: 1000
      },
      animationInObject3: {
        classes: 'slideInRight',
        delay: 1500
      },
      contentIndex: 0,
      blockScroll: false
    }
  },
  props: ['landscape'],
  components: {
    Part1,
    Part2,
    Part3,
    Touch
  },
  created () {
    const self = this
    this.setWidth()
    window.addEventListener('resize', function () {
      self.setWidth()
    })
  },
  methods: {
    setWidth: function () {
      if (this.landscape) {
        this.dashboardWidth = '21.5rem'
      } else {
        this.dashboardWidth = '24rem'
      }
    },
    wheelHandler: function (event) {
      if (event.deltaX > 0 || event.deltaY > 0) {
        if (this.landscape) {
          this.moveRight()
        } else {
          this.moveToPortrait(1)
          this.blockScroll = true
        }
      } else {
        if (this.landscape) {
          this.moveLeft()
        } else {
          this.moveToPortrait(-1)
          this.blockScroll = true
        }
      }
    },
    moveLeft: function () {
      this.$refs.dashboard.style.transform = 'translateX(0px)'
      this.$refs.dashboard.style.transition = '.5s'
    },
    moveRight: function () {
      // block_widths + block_paddings + wrapper_paddings - screen_base_width
      this.$refs.dashboard.style.transform = 'translateX(-6rem)'
      this.$refs.dashboard.style.transition = '.5s'
    },
    moveToPortrait: function (direction) {
      const self = this
      if (!this.blockScroll) {
        this.blockScroll = true
        if ((direction > 0 && this.contentIndex < 2) || (direction < 0 && this.contentIndex > 0)) {
          this.contentIndex += direction
          this.$refs.dashboard.style.transform = `translateX(-${this.contentIndex * 8}rem)`
          this.$refs.dashboard.style.transition = '.5s'
        }
        setTimeout(() => {
          self.blockScroll = false
        }, 500)
      }
    },
    slideHandler: function (direction) {
      if (direction < 0) {
        this.moveToPortrait(1)
      } else {
        this.moveToPortrait(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../Global.scss';
.content {
  height: 5rem;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.dashboard {
  height: 4rem;
  @include flexBox(row, nowrap, space-between, center);
  margin-top: .2rem;
  padding: 0 1rem;
  a {
    display: block;
    height: 100%;
  }
}
.mouse {
  width: .8rem;
  height: .28rem;
  position: relative;
  margin: .5rem auto;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
  }
  .btn-left {
    width: .3rem;
    height: .3rem;
    position: absolute;
    left: 0;
  }
  .btn-right {
    @extend .btn-left;
    left: auto;
    right: 0;
  }
}
.dashboard-portrait {
  @extend .dashboard;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue